// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oq-1";
export var messageSideRight = "_oq-2";
export var orderLookupBubbleContainer = "_oq-0";
export var submitButton = "_oq-3";